import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, TextField } from '@material-ui/core'
import { FLEX } from '@v4/constants/quiz'
import useStyles from './InputField.styled'

const InputField = props => {
	const { type = 'text', onChange, multiline, value, amount, maxLength, min, max, step } = props
	const classes = useStyles(props)

	return (
		<Box className={classes.content}>
			<TextField
				type={type}
				aria-label="answers"
				name="answers"
				multiline={multiline}
				rows={multiline ? 5 : 1}
				InputProps={
					multiline
						? {
								className: clsx(classes.multiline, classes.field),
								classes: {
									input: classes.textarea,
									notchedOutline: classes.notchedOutline,
								},
						  }
						: {
								className: classes.field,
								classes: {
									input: classes.input,
									notchedOutline: classes.notchedOutline,
								},
						  }
				}
				inputProps={{
					maxLength,
					min,
					max,
					step,
				}}
				value={value}
				onChange={onChange}
			/>
			<span className={classes.amount}>{amount}</span>
		</Box>
	)
}

InputField.propTypes = {
	justify: PropTypes.oneOf(Object.values(FLEX)),
	withBgImage: PropTypes.bool,
	multiline: PropTypes.bool,
	value: PropTypes.string,
	onChange: PropTypes.func,
	amount: PropTypes.string,
	type: PropTypes.string,
	maxLength: PropTypes.number,
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
	classes: PropTypes.shape({
		content: PropTypes.string,
	}),
}

export default memo(InputField)
